@use '@lib/assets/styles/main.scss' as *;

.body {
  display: grid;
  grid-row-gap: 16px;
}



